var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          staticClass:
            "col-12 col-lg-8 col-xl-7 text-center text-lg-left justify-content-center d-flex flex-column align-items-center align-items-lg-start order-1 order-lg-0"
        },
        [
          _c("h2", {
            staticClass: "mb-16",
            class: {
              "mb-md-40": !_vm.description,
              "mb-md-24": _vm.description
            },
            domProps: { innerHTML: _vm._s(_vm.title) }
          }),
          _vm._v(" "),
          _vm.description
            ? _c("p", { staticClass: "mb-16 mb-md-40 font-weight-light" }, [
                _vm._v(_vm._s(_vm.description))
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex align-items-center flex-column flex-lg-row"
            },
            [
              _c(
                "a",
                {
                  staticClass: "btn btn-accent text-center",
                  attrs: { href: "/" + _vm.ctaLink }
                },
                [
                  _vm._v(_vm._s(_vm.cta) + " "),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(_vm.svg("arrow-right", "arrow-right"))
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _vm.email
                ? _c(
                    "a",
                    {
                      staticClass:
                        "ml-lg-32 small text-dark mr-lg-16 mt-32 mt-lg-0",
                      attrs: { href: "mailto:" + _vm.email }
                    },
                    [_vm._v(_vm._s(_vm.email))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.email && _vm.phone
                ? _c("span", { staticClass: "small d-none d-lg-inline" }, [
                    _vm._v("|")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.phone
                ? _c(
                    "a",
                    {
                      staticClass: "ml-lg-16 small text-dark mt-16 mt-lg-0",
                      attrs: { href: "tel:" + _vm.phone }
                    },
                    [_vm._v(_vm._s(_vm.phone))]
                  )
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "col-12 col-lg-4 col-xl-5 d-flex justify-content-center justify-content-lg-end order-0 order-lg-1 mb-24 mb-lg-0"
        },
        [
          _c("img", {
            staticClass: "circle",
            attrs: { src: _vm.src, alt: _vm.title }
          })
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }